import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { FieldArray } from 'react-final-form-arrays'
import Icon from '@material-ui/core/Icon'
import Link from '@material-ui/core/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import Collapsible from 'react-collapsible';
import {
  SortableDragHandle,
  SortableContainer,
  SortableItem
} from 'components/Sortable';

const useCompare = (val) => {
  const prevVal = usePrevious(val)
  return prevVal !== val
}

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}


const AddGroupBttn = styled.div`
  margin-top: 15px;
  font-weight: 400;
  cursor: pointer;
  border-style: solid;
  border-width: 0px;
  color: #98a1b3;
  font-size: 12px;
  border-top: 1px dashed;
  border-bottom: 1px dashed;
  padding: 4px 0 4px 0;
  &:hover p, :hover span {
    color: #3adbd5;
  }
  &::first-letter {
  }
  p {
    display: inline;
  }
  `
  
const AddDeleteBttn = styled.div`
margin-top: 15px;
font-weight: 400;
cursor: pointer;
text-align: right;
border-width: 0px;
color: #98a1b3;
font-size: 12px;
padding: 4px 0 4px 0;
&:hover p, :hover span {
  color: #3adbd5;
}
&::first-letter {
  color: red;
}
p {
  display: inline;
}
img {
  width: 14px;
  display: inline;
  height: auto;
  color:  #98a1b3;
}
width: auto;
float: right;
`

const RemoveBttn = styled.span`
  margin: 0 1rem;
  cursor: pointer !important;
  &:hover  {
    color: #3adbd5;
  }
`

const FieldGroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0px;
  background-color: transparent;
  transition: all 0.3s ease;
  &span:hover {
    color: #3adbd5;
    cursor: pointer !important;
  }
  &div:hover {
    color: #3adbd5;
  }
`

const FieldGroupPreview = styled.div`
  flex: 1;
  cursor: pointer;
  &hover {
    color: #3adbd5;
  }
  &div:first-child {
    color: red;
    background: red;
  }
`


const ArrowIcon = styled(Icon)`
  transition: all 0.5s ease;
  font-size: 1.2rem;
  cursor: pointer !important;
  margin-top: -2px;
  ${({open}) => `
  svg {
    transform: ${open ? 'rotateZ(180deg)' : 'rotateZ(0)'};
  }
  `}
  &:hover {
    color: #3adbd5;
  }
`

const CollapsibleContentWrapper = styled.div`
  padding: 0.5rem 0;
`

const DragHandle = styled.div`
  margin: 0 0.5rem 0 0.5rem;
  cursor: move !important;
  &hover {
    color: #3adbd5 !important;
  }
`


const DeleteOutlinedIconStyled = styled.div`
  margin: 0 0.5rem 0 0.5rem;
  cursor: move !important;
  &hover {
    color: #3adbd5 !important;
  }
`


const CollapsibleFieldsGroup = ({
  children,
  label,
  initialyOpen,
  onRemoveClick,
  open,
  handleTriggerClick
}) => {
  const header = (
    <>
    <SortableDragHandle disable>
      <FieldGroupHeader>
        <DragHandle>=</DragHandle>
        <FieldGroupPreview>
          {label}
        </FieldGroupPreview>

      </FieldGroupHeader>
    </SortableDragHandle>
      <div className="rightToolbar">
        <RemoveBttn
              onClick={(e) => {
                e.stopPropagation()
                onRemoveClick()
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </RemoveBttn>
            <ArrowIcon
              open={open}
            >
              <FontAwesomeIcon icon={faAngleDown} />
            </ArrowIcon>
      </div>
    </>
  )
  return (
    <Collapsible
      transitionTime={300}
      trigger={header}
      open={open}
      handleTriggerClick={handleTriggerClick}
    >
      <CollapsibleContentWrapper>
        {children}
      </CollapsibleContentWrapper>
    </Collapsible>
  )
}


const MultiFieldsGroup = ({
  mutators: { push, pop },
  name,
  label,
  fieldToPreview,
  renderFieldsGroup
}) => {
  const [accordionControl, setAccordionControl] = useState([])

  return (
    <>
      <FieldArray name={name}>
        {({ fields }) => {
          const onSortEnd = ({oldIndex, newIndex}) => {
            fields.move(oldIndex, newIndex)
          };
          return (
            <SortableContainer onSortEnd={onSortEnd} useDragHandle={true}>
              {
                fields.map((fieldName, index) => {
                  const value = fields.value[index]
                  let groupLabel = 'Nie wprowadzone'
                  if (value && value[fieldToPreview]){
                    groupLabel = value[fieldToPreview]
                    if (label == 'zatrudnienie') groupLabel = value[fieldToPreview] + ' - ' + value['employer'];
                  }
                  return (
                    <SortableItem
                      key={`item-${index}`}
                      index={index}
                    >
                      <DragHandle />
                      <CollapsibleFieldsGroup
                        key={[fieldName, index].join('-')}
                        id={index}
                        initialyOpen={true}
                        label={groupLabel}
                        onRemoveClick={() => fields.remove(index)}
                        open={
                          (accordionControl[index] === undefined ) ? index === (fields.length - 1) :
                            accordionControl[index]
                        }
                        handleTriggerClick={() => {
                          const accordion = fields.map(() => false)
                          accordion[index] = !accordionControl[index]
                          setAccordionControl(accordion)
                        }}
                      >
                        {renderFieldsGroup(fieldName, index)}
                        <AddDeleteBttn
                          onClick={() => fields.remove(index)}
                        >
                          <div className="delete">
                            <DeleteOutlinedIcon /> Usuń {label}
                          </div>
                        </AddDeleteBttn>
                      </CollapsibleFieldsGroup>
                    </SortableItem>
                  )
                })
              }
            </SortableContainer>
          )
        }}
      </FieldArray>
      <AddGroupBttn
        onClick={() => push(name, undefined)}
      >
        <span className="plus-icon">+</span> <p>Dodaj {label}</p>
      </AddGroupBttn>
    </>
  )
}

export default MultiFieldsGroup
